import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, Container, Image } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from '../ApiFetch';
import { useTranslation } from "react-i18next";
import { Button, Card, CardContent, CardHeader, CardMedia, Chip, Divider, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { LoginInfo } from '../../App';
import FollowButton from '../FollowButton';
import LoadingButton from '@mui/lab/LoadingButton';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

const GiftCard = (props) => {
  function update(rewardsId,status,entryCount){
    return new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/rewards/status",{
        rewardsId:rewardsId,status:status,entryCount:entryCount
    }).then((r)=>r.json().then((json)=>{
        return json
    }))
  }
  // 翻訳
  const {t,i18n} = useTranslation()
  // ログイン情報
  const {loginInfo,setLoginInfo} = useContext(LoginInfo)
  // ナビゲート
  const navigate = useNavigate()
  const location = useLocation()
	const [terms,setTerms] = useState("")
  const [loading,setLoading] = useState(false)
  const [rewardsInfo,setRewardsInfo] = useState(props.data)
  const [status,setStatus] = useState("")
  const [entryCount,setEntiryCount] = useState(0)

	useEffect(() => {
    setStatus(rewardsInfo.status)
	},[rewardsInfo])

  function getLabel(status){
    if(status == null || status == "") return "応募する"
    if(status == "PENDING") return "応募済"
    if(status == "WON") return "当選"
    if(status == "LOST") return "落選"
    return ""
  }

    return(
      <Card 
        sx={{ 
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '12px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
            transform: 'translateY(-2px)'
          }
        }}
      >
        <CardMedia 
          component={"img"} 
          image={"/img/ourt_logo_dashed.png"} 
          sx={{
            height: 140,
            objectFit: 'cover',
            backgroundColor: '#f8f9fa'
          }}
        />
        <CardHeader 
          title={
            <span style={{
              fontSize:"18px", 
              fontWeight:"bold", 
              color:"#2c5aa0",
              lineHeight: "1.3"
            }}>
              {rewardsInfo.item_name}
            </span>
          } 
          sx={{
            paddingBottom: 1,
            '& .MuiCardHeader-title': {
              fontSize: '18px'
            }
          }}
        />
        <CardContent 
          sx={{ 
            flexGrow: 1,
            paddingTop: 0,
            paddingBottom: 1
          }}
        >
          <div style={{
            wordBreak:"break-all",
            wordWrap:"break-word",
            whiteSpace:"pre-wrap",
            fontSize: "14px",
            color: "#6c757d",
            lineHeight: "1.5",
            maxHeight: "80px",
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 4,
            WebkitBoxOrient: "vertical"
          }}>
            {rewardsInfo.description}
          </div>
        </CardContent>
        <CardContent sx={{ paddingTop: 1 }}>
          <div className='text-center'>
            {status == null || status == "" ? (
              <FormControl fullWidth sx={{ marginBottom: 2 }}>
                <InputLabel id="entry-count-label">応募口数</InputLabel>
                <Select
                  labelId="entry-count-label"
                  id="entry-count"
                  value={entryCount}
                  label="応募口数"
                  size="small"
                  onChange={(e) => setEntiryCount(e.target.value)}
                >
                {[... new Array(100)].map((d,i) => {
                    let point = 0
                    if(i < 10 && (loginInfo.plan === "unlimited" || loginInfo.plan === "plus")){
                      point = 0
                    } else {
                      if(loginInfo.plan === "unlimited" || loginInfo.plan === "plus"){
                        point = 5000 * (i - 9)
                        if(point < 0) point = 5000
                      } else {
                        point = 5000 * (i + 1) 
                      }
                    }
                    return <MenuItem key={i} value={i+1}>{i+1}口 ({point.toLocaleString()}ポイント)</MenuItem>
                })}
                </Select>
              </FormControl>
            ) : ""}
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {status == "WON" || status == "LOST" ? (
                <div style={{ marginBottom: '8px' }}>
                  {status == "WON" ? 
                    <Chip 
                      label={<><CheckCircleIcon style={{color:"#28a745", fontSize: "18px"}} /> 当選</>} 
                      sx={{ 
                        backgroundColor: "#d4edda", 
                        color: "#155724",
                        fontWeight: "bold"
                      }}
                    /> :
                    <Chip 
                      label={<><CancelIcon style={{color:"#6c757d", fontSize: "18px"}} /> 落選</>} 
                      sx={{ 
                        backgroundColor: "#f8f9fa", 
                        color: "#6c757d",
                        fontWeight: "bold"
                      }}
                    />
                  }
                </div>
              ) : (
                <>
                  <LoadingButton 
                    variant={status == 'PENDING' ? 'contained' : 'outlined'} 
                    size="small"
                    fullWidth
                    sx={{
                      borderRadius: '8px',
                      textTransform: 'none',
                      fontWeight: '600',
                      fontSize: '14px'
                    }}
                    onClick={(e) => {
                      let afterStatus = ""
                      if(status == null || status == "") {
                        afterStatus = "PENDING"
                      }
                      if(status == "PENDING"){
                        afterStatus = "CANCELED"
                      }
                      setLoading(true)
                      update(rewardsInfo.id,afterStatus,entryCount).then(r => {
                          if(r.result){
                              setStatus(r.data.status)
                          } else {
                              alert(r.errors)
                          }
                          setLoading(false)
                      })
                    }} 
                    loading={loading} 
                    disabled={status == "WON" || status == "LOST" || status == 'PENDING'}
                  >
                    {getLabel(status)}
                  </LoadingButton>
                  
                  {status === "PENDING" && (
                    <LoadingButton 
                      color='warning' 
                      variant={'outlined'} 
                      size="small"
                      fullWidth
                      sx={{
                        borderRadius: '8px',
                        textTransform: 'none',
                        fontWeight: '600',
                        fontSize: '14px'
                      }}
                      onClick={(e) => {
                        setLoading(true)
                        update(rewardsInfo.id,"CANCELED",entryCount).then(r => {
                            if(r.result){
                                setStatus(r.data.status)
                            } else {
                                alert(r.errors)
                            }
                            setLoading(false)
                        })
                      }} 
                      loading={loading} 
                      disabled={status == "WON" || status == "LOST"}
                    >
                      キャンセル
                    </LoadingButton>
                  )}
                </>
              )}
            </div>
          </div>
        </CardContent>
      </Card>
    )
}

export default GiftCard;
